import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

const FieldValidationError: React.FC<ValueFieldProps> = (props) => (
  <div>
    {props.errors.map((error, index) => (
      <p
        className="text-xs font-bold text-error"
        key={`error-${props.field.fieldIdField.id}-${index}`}
      >
        {error}
      </p>
    ))}
  </div>
);
export default FieldValidationError;
